"use client";

import { AlertTriangle, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="mx-auto flex min-h-[60vh] max-w-5xl flex-col items-center justify-center px-4 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10">
        <AlertTriangle className="h-7 w-7 text-destructive" />
      </div>
      <h1 className="text-lg font-bold">页面出了点问题</h1>
      <p className="mt-2 max-w-sm text-sm leading-relaxed text-muted-foreground">
        加载时发生错误，可能是网络波动或后端服务暂时不可用。
        {error.digest && (
          <span className="mt-1 block text-xs opacity-60">错误标识：{error.digest}</span>
        )}
      </p>
      <div className="mt-6 flex gap-2">
        <Button onClick={reset}>
          <RotateCcw className="h-4 w-4" />
          重试
        </Button>
      </div>
    </main>
  );
}
